import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { getOriginalProductPrice } from '../../../helpers/getProductValue'
import { formatCurrency } from '../../../../../../../../../helpers/numbers'

const RateCell = ({ productValues, currencySymbol }) => {
  const isProductLoading = productValues.isLoading
  // used on add bulk products
  const isInventoryLoading = productValues.isInventoryLoading
  const isProductSelected = Boolean(productValues.data)

  if (isProductLoading || isInventoryLoading) {
    return <Skeleton width="100%" />
  } else if (isProductSelected) {
    const totalPrice = getOriginalProductPrice(productValues)

    return formatCurrency(totalPrice, { min: 2, max: 2 }, { symbol: currencySymbol })
  } else {
    return ''
  }
}

export default RateCell
